import React from 'react';

import { formatDistance } from '@lt/components/utils/userflow';
import { BeachPalmTree } from '@lt/components/icons-react/rebrand';
import HotelFeature from '../HotelFeature';

import styles from './beachDistanceFeature.module.css';

type BeachDistanceFeatureProps = {
  value: number | null;
  isMobile: boolean;
};

const BeachDistanceFeature: React.FC<BeachDistanceFeatureProps> = ({
  value,
  isMobile,
}) =>
  value ? (
    <HotelFeature
      Label={formatDistance(value)}
      Icon={<BeachPalmTree className={styles.iconContainer} />}
      isMobile={isMobile}
    />
  ) : null;

export default BeachDistanceFeature;
